import React, { useState } from "react";
import { Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import "./app.css"
import "./media.css"
import Header from "./component/header/header";
import Section from "./component/section/section";
import Footer from "./component/footer/footer";
import TourDetails from "./component/pages/tourDetails/tourDetails";
import Request from "./component/pages/request/request";
import Gallery from "./component/pages/gallery/gallery";
import About from "./component/pages/about/about";
import Tours from "./component/pages/tours/tours";
import Contact from "./component/pages/contact/contact";
import Feedback from "./component/pages/feedback/feedback";
import "./component/font-awesome-4.7.0/css/font-awesome.css"
import "./component/font-awesome-4.7.0/css/font-awesome.min.css"
import { useTranslation } from "react-i18next";
import useLocalStorage from "./hooks/use-localstorage";
import i18n from './i18n';
const App = () => {
    const { t } = useTranslation();
    const [language, setLanguage] = useLocalStorage('language', 'ru');
    const activeheadChange = () => {
        const headChangeVisible = document.querySelector(".head-3-change");
        if (headChangeVisible.classList.contains("active") == true) {
            headChangeVisible.classList.remove("active")
        }
        else {
            headChangeVisible.classList.add("active")

        }
    }
    const activeheadMenu = () => {
        const headChangeVisible = document.querySelector(".head-2-menu");
        if (headChangeVisible.classList.contains("active") == true) {
            headChangeVisible.classList.remove("active")
        }
        else {
            headChangeVisible.classList.add("active")

        }
    }
    const [langcat, setlangcat] = useState(language);
    const changeLang = (e) => {
        const headChangeVisible = document.querySelector(".head-3-change");
        if (e === 'ru') {
            setlangcat(e)
            i18n.changeLanguage('ru');
            setLanguage('ru');
            headChangeVisible.classList.remove("active")
            window.scrollTo(0, 0)

        }
        if (e === 'eng') {
            setlangcat(e)
            i18n.changeLanguage('eng');
            setLanguage('eng');
            headChangeVisible.classList.remove("active")
            window.scrollTo(0, 0)

        }
    };
    const [tourId, setTourId] = useState("");
    const [openReq, setOpenReq] = useState(false);
    const [scoreTours, setScoreTours] = useState(0)

    return (
        <>
            <Request
                t={t}
                tourId={tourId}
                setTourId={setTourId}
                openReq={openReq}
                setOpenReq={setOpenReq}
                langcat={langcat}
            />
            <Header
                activeheadChange={activeheadChange}
                activeheadMenu={activeheadMenu}
                changeLang={changeLang}
                setOpenReq={setOpenReq}
                t={t}
            />
            <Routes>
                <Route path="/" element={<Section
                    langcat={langcat}
                    setOpenReq={setOpenReq}
                    t={t}
                />} />
                <Route path="/robots.txt" element="../robots.txt" />
                <Route path="/sitemap.xml" element="../sitemap.xml" />
                <Route exact path="/tours/:id" element={<TourDetails
                    langcat={langcat}
                    setTourId={setTourId}
                    setOpenReq={setOpenReq}
                    setScoreTours={setScoreTours}
                    scoreTours={scoreTours}
                    t={t}
                />} />
                <Route path="/gallery" element={<Gallery
                    t={t}
                />} />
                <Route path="/about" element={<About
                    t={t}
                />} />
                <Route path="/tours" element={<Tours
                    langcat={langcat}
                    t={t}
                />} />
                <Route path="/contact" element={<Contact
                    t={t}
                />} />
                <Route path="/feedback/:id" element={<Feedback
                    t={t}
                />} />
            </Routes>
            <Footer
                t={t}
            />
        </>
    )
}
export default App;